import { BadgeProps } from "@mantine/core"
import { StatusBadge } from "@tfg/ui"

import { useGetOperations } from "~/utils/operations"

type Props = BadgeProps & {
  activityName: string
}
export const ActivityBadge = ({ activityName }: Props) => {
  const activityInfo = useGetOperations()[activityName]
  return (
    <StatusBadge
      text={activityInfo.name}
      icon={activityInfo?.icon ? <activityInfo.icon size={12} /> : null}
      variant="info"
    />
  )
}
